import { LikeOrDislikeResponse } from "../../types/Like"

/**
 * Retrieves all likes for a specific firm
 * 
 * @param {number} firmId - The unique identifier of the firm to get likes for
 * 
 * @returns {Promise<LikeOrDislikeResponse>} A promise that resolves to an object containing:
 *  - The total count of likes for the firm
 *  - An array of like objects with details about each like
 * 
 * @throws {Error} If firmId is not provided or is invalid
 * @throws {Error} If the API request fails or returns an invalid response
 * 
 * @example
 * // Get likes for a firm
 * try {
 *   const result = await getLikesByFirmId(123);
 *   console.log(`Firm has ${result.count} likes`);
 *   console.log('Likes:', result.likes);
 * } catch (error) {
 *   console.error('Failed to get likes:', error);
 * }
 */
export async function getLikesByFirmId(firmId: number) {
  if (!firmId) {
    throw new Error('Firm ID is required')
  }

  const response = await fetch(`https://cms.tech.lamacompta.co/api/accounting-like-custom/byFirmId/${firmId}`, {
    method: 'GET',
  })

  const responseData = (await response.json()) as LikeOrDislikeResponse
  return responseData || { count: 0, likes: [] }
}
